import {UserAuthenticationBaseRequestDto, UserAuthenticationBaseResponseDto} from './user-authentication-base.dto';
import {AutoMap} from '@automapper/classes';

export class RefreshTokenRequestDto extends UserAuthenticationBaseRequestDto {
  @AutoMap()
  public accessToken!: string

  @AutoMap()
  public refreshToken!: string
}

export class RefreshTokenResponseDto extends UserAuthenticationBaseResponseDto {

}
